import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Page title and breadcrumbs from the URL, e.g. /DATA FEEDING/LAB DATA ->
 * "LAB DATA" with HOME / DATA FEEDING / LAB DATA. Every crumb but the last
 * one (the current page) can be clicked.
 */
export default function TittleAndBreadCrumb() {
  const navigate = useNavigate();
  const location = useLocation();
  const parts = location.pathname
    .substring(1)
    .split("/")
    .map(decodeURIComponent)
    .filter(Boolean);
  // Old 4-part addresses (/Dashboard/SECTION/GROUP/PAGE) skip the first part.
  const trail = parts.length === 4 ? parts.slice(1) : parts;

  const crumbs = [{ name: "HOME", to: "/" }];
  trail.forEach((name, index) => {
    const to =
      index === 0
        ? `/${name.toUpperCase()}`
        : `/Dashboard/${trail
            .slice(0, index + 1)
            .map((part) => part.toUpperCase())
            .join("/")}`;
    crumbs.push({ name: name.toUpperCase(), to });
  });
  const title = crumbs[crumbs.length - 1].name;

  return (
    <div className="pagetitle">
      <h1>{title === "HOME" ? "" : title}</h1>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {crumbs.map((crumb, index) =>
            index === crumbs.length - 1 ? (
              <li key={index} className="breadcrumb-item active" aria-current="page">
                {crumb.name}
              </li>
            ) : (
              <li key={index} className="breadcrumb-item">
                <button
                  type="button"
                  className="breadcrumb-link"
                  onClick={() => navigate(crumb.to)}
                >
                  {crumb.name}
                </button>
              </li>
            )
          )}
        </ol>
      </nav>
    </div>
  );
}
